<template>
    <div class="columns invoice-filter-component">
        <div class="column is-12">
        	<div class="header filter-card-header">
        		<p>Filters</p>
			</div>
			<div class="card-content content">
				<div class="field">
					<div class="field-body">
						<label class="label">Invoice Number</label>
						<b-field>
				            <b-input v-model="filter.invoice_number" placeholder="Search Invoice Number"></b-input>
				        </b-field>
					</div>
				</div>

				<div class="field">
					<div class="field-body">
						<label class="label">Batch ID</label>
						<b-field>
							<b-autocomplete
								expanded
								v-model="filter.batch_id"
								:data="filteredBatch"
								placeholder="Search Batch ID"
								@typing="query => searchBatch()"
							></b-autocomplete>
				        </b-field>
					</div>
				</div>

				<base-select
					:service="firmService"
					fetch-func="allFirms"
					value-key="id"
					label="Recived From"
					label-key="name"
					:horizontal="true"
      				custom-class="invoice-received-from"
					:value.sync="filter.recived_from">
					<template v-slot:defaultOptionLabel>All</template>
				</base-select>

				<div class="field">
					<div class="field-body">
						<label class="label">Approved By</label>
						<b-field>
							<b-autocomplete
								expanded
								v-model="approved_by"
								field="firstName"
								:data="users"
								placeholder="Search User"
								@select="option => (filter.approved_by = option ? option.id : null)"
								@typing="query => searchUser(query)"
							></b-autocomplete>
				        </b-field>
					</div>
				</div>

				<div class="field">
					<div class="field-body">
						<label class="label">Invoice Date</label>
						<b-field>
							<b-datepicker
								icon="calendar"
								v-model="filter.invoice_date"
				                trap-focus>
				            </b-datepicker>
				        </b-field>
					</div>
				</div>

				<div class="field">
					<div class="field-body">
						<label class="label">Invoice Value</label>
						<b-field>
				            <b-input v-model="filter.invoice_value"></b-input>
				        </b-field>
					</div>
				</div>
				
				<!-- <div class="field">
					<div class="field-body">
						<label class="label">Tags</label>
						<b-field>
              				<tags-input placeholder="Select Tag" :values.sync="filter.tags" />
				        </b-field>
					</div>
				</div> -->

				<base-tag-input :value.sync="filter.tags" horizontal />

				<div class="field">
					<div class="field-body">
						<label class="label">Match Status</label>
						<b-field>
							<b-radio v-model="filter.match_status" name="match_status" :native-value="null"> All </b-radio>
							<b-radio v-model="filter.match_status" name="match_status" :native-value="0"> Unmatched </b-radio>
							<b-radio v-model="filter.match_status" name="match_status" :native-value="1"> Matched </b-radio>
				        </b-field>
					</div>
				</div>

				<div class="field">
					<div class="field-body">
						<label class="label">Approval Status</label>
						<b-field>
							<b-radio v-model="filter.approval_status" name="approval_status" :native-value="null"> All </b-radio>
							<b-radio v-model="filter.approval_status" name="approval_status" :native-value="0"> Unapproved </b-radio>
							<b-radio v-model="filter.approval_status" name="approval_status" :native-value="1"> Approved </b-radio>
				        </b-field>
					</div>
				</div>

				<div class="field">
					<div class="field-body">
						<label class="label">Batch Status</label>
						<b-field>
							<b-radio v-model="filter.batch_status" name="batch_status" :native-value="null"> All </b-radio>
							<b-radio v-model="filter.batch_status" name="batch_status" :native-value="0"> Unbatched </b-radio>
							<b-radio v-model="filter.batch_status" name="batch_status" :native-value="1"> Batched </b-radio>
				        </b-field>
					</div>
				</div>

				<div class="field">
					<div class="field-body">
						<label class="label">Void Status</label>
						<b-field>
							<b-radio v-model="filter.void_status" name="void_status" :native-value="null"> All </b-radio>
							<b-radio v-model="filter.void_status" name="void_status" :native-value="0"> Void </b-radio>
							<b-radio v-model="filter.void_status" name="void_status" :native-value="1"> Active </b-radio>
				        </b-field>
					</div>
				</div>
			</div>

			<div class="card-footer">
				<button class="button is-fullwidth" style="margin-bottom:5px;" @click="resetFilter">Reset</button>
				<button class="button is-info is-fullwidth" @click="submitFilter">Filter</button>
			</div>

    	</div>
    </div>
</template>
<script>
import debounce from "lodash/debounce";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer.js";
import { BatchService } from "@/services/batch.service";
import { UserService } from "@/services/user.service";
import { FirmService } from "@/services/firm.service";
import TagsInput from "@/components/partials/TagsInput";
import BaseSelect from "@/components/partials/BaseSelect";
import BaseTagInput from "@/components/partials/BaseTagInput";
export default {
	components: {
		BaseSelect,
		TagsInput,
		BaseTagInput,
	},
	props: [ 'params' ],
    data: () => ({
        firmService: FirmService,
    	batches: [],
    	users: [],
    	approved_by: null,
    	filter: {
    		invoice_number: null,
    		batch_id: null,
    		recived_from: null,
    		approved_by: null,
    		invoice_date: null,
    		match_status: null,
    		approval_status: null,
    		batch_status: null,
    		void_status: null,
    		tags: [],
    		invoice_value: null,
    	}
    }),
    computed: {
    	filteredBatch() {
    		return this.batches.map(element => element.id + ' - ' + element.text);
    	},
    	// filteredUser() {
    	// 	return 
    	// }
    },
    methods: {
    	resetFilter() {
    		this.approved_by = null
			this.batches = []
			this.users   = []
			this.filter  = {
	    		invoice_number: null,
	    		batch_id: null,
	    		recived_from: null,
	    		approved_by: null,
	    		invoice_date: null,
	    		match_status: null,
	    		approval_status: null,
	    		batch_status: null,
	    		void_status: null,
	    		tags: [],
	    		invoice_value: null,
	    	}
	    	this.$nextTick(() => {
	    		this.submitFilter();
	    	});
    	},
    	submitFilter() {
    		this.$emit('update:params', this.filter)
    		this.$emit('filter')
    	},
		searchBatch: debounce(function() {
			if (this.filter.batch_id) {
				BatchService.search(this.filter.batch_id).then(response => {
					this.batches = JsonDenormalizer.denormalize(response);
				});
			} else {
				this.batches = [];
			}
		}, 500),
		async iniatialGet() {
    		let batchName = this.$route.query.name || null
			if (batchName) {
				await BatchService.findByColumn('text', batchName).then(response => {
					if (response) {
						this.filter.batch_id = JsonDenormalizer.denormalize(response).id
					}
				});
			}
			this.submitFilter();
		},
		searchUser: debounce(function(keyword) {
			if (keyword) {
				UserService.search(keyword).then(response => {
					this.users = JsonDenormalizer.denormalize(response)
				})
			}
		}, 500),

    },
    mounted() {
    	this.iniatialGet();
    }
};
</script>

<style lang="scss">
.invoice-filter-component {
	.invoice-received-from {
		width: 132px;
	}
	.filter-card-header {
		padding: 10px 10px 15px;
		font-size: 20px;
	}
	.field-body > label {
		width: 150px;
	}
	.field-body .b-radio {
		width: 100px;
		margin-right: 30px; 
	}
}
</style>


// WEBPACK FOOTER //
// src/components/pages/invoices/filter.vue